<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between;">
      <!-- 搜索 -->
      <div>
        <el-select v-model="departCenterId" placeholder="请选择管理中心" style="width: 250px;" size="mini" filterable
                   clearable @clear="initRep">
          <el-option v-for="item in departments" :key="item.code" :label="item.name" :value="item.code">
          </el-option>
        </el-select>
        <span style="margin-right: 10px;"></span>
        <el-date-picker v-model="rqScope" size="mini" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @clear="initRep">
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="initRep" style="margin-left: 10px;" size="mini">
          搜索
        </el-button>
      </div>
      <!-- 右边工具 -->
      <div>
        <el-button type="success" @click="downloadExcel" style="margin-left: 10px;" size="mini"> <i
            class="fa fa-level-down" aria-hidden="true"></i> 导出数据</el-button>

      </div>

    </div>


    <div style="margin-top: 20px;">
      <el-table :data="reportData" :span-method="spanMethod" :summary-method="showSummary" show-summary
                :header-cell-style="{background:'#eef1f6',color:'#606266',borderColor:'white'}" :row-style="rowStyle"
                style="width: 100%" size="mini" id="mytable" ref="mytable" border stripe height="550" :cell-style="cellStyle">
        <el-table-column prop="centerName" label="管理中心名称" align="center"   width="130">
        </el-table-column>
        <el-table-column prop="departmentName" label="部门名称" align="center"   width="130">
        </el-table-column>
        <el-table-column label="收款(元)" align="center" prop="income"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.income)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="工资(元)" align="center" prop="f1"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f1)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="办公费(元)" align="center" prop="f2"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f2)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="公关招待费(元)" align="center" prop="f3"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f3)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="房租费(元)" align="center" prop="f4"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f4)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="修理费(元)" align="center" prop="f5"   width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f5)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="水电物业费(元)" align="center" prop="f6"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f6)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="差旅费(元)" align="center" prop="f7"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f7)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="交通费(元)" align="center" prop="f8"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f8)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="固定资产(元)" align="center" prop="f9"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f9)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="无形资产(元)" align="center"  prop="f10"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f10)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="装修费(元)" align="center" prop="f11"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f11)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="通讯费(元)" align="center" prop="f12"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f12)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="五险一金(元)" align="center" prop="f13"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f13)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="车辆使用费(元)" align="center" prop="f14"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f14)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="咨询费(元)" align="center" prop="f15"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f15)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="三项经费(元)" align="center" prop="f16"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f16)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="奖金(元)" align="center" prop="f17"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f17)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="运输费(元)" align="center" prop="f18"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f18)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="广告宣传费(元)" align="center" prop="f19"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f19)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="税金(元)" align="center" prop="f20" width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f20)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="其他费用(元)" align="center" prop="f21"  width="130">
          <template #default="{row}">
            <span>{{moneyNumber(row.f21)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>


  </div>
</template>

<script>
import FileSaver from "file-saver"
import XLSX from "xlsx"

export default {
  name: "DepaReport",
  data() {
    return {
      reportData: [], // 存放查询结果
      spanArr: [],
      pos: 0,
      departCenterId: null,
      rqScope: '',
      departments: [], //部门id-部门名称下拉框
    }
  },
  mounted() {
    this.initRep()
    this.initDim()
  },
  methods: {
    moneyNumber(val){
      if (!val) return 0
      else return val.toLocaleString(undefined, {'minimumFractionDigits':2,'maximumFractionDigits':2})
    },
    initRep() {
      this.loading = true
      let url = '/depa/report-center-detail?'

      if (this.departCenterId) {
        url += 'departCenterId=' + this.departCenterId + '&'
      }

      if (this.rqScope) {
        url += '&rqScope=' + this.rqScope
      }
      this.getRequest(url).then(resp => {
        if (resp) {
          this.reportData = resp.result
          this.getSpanArr(resp.result)
        }
      })
    },
    initDim() {
      if (!window.sessionStorage.getItem('centers')) {
        this.postRequest('/dim/dim_table_char/center').then(resp => {
          if (resp) {
            this.departments = resp.result
            this.saveDictCache('center', resp.result)
          }
        })
      } else {
        this.departments = this.dictCache('center')
      }
    },
    downloadExcel() {
      var wb = XLSX.utils.table_to_book(document.querySelector("#mytable")); //mytable为表格的id名
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
            new Blob([wbout], {
              type: "application/octet-stream"
            }),
            "管理中心统计报表.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    /**
     * 数据列合并
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     */
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    getSpanArr(data) {
      this.spanArr = []
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0
        } else {
          if (data[i].centerName === data[i - 1].centerName) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    /**
     * 表尾合计行
     * @param columns
     * @param data
     */
    showSummary( { columns, data }){
      // fix-初始合计行不显示bug
      this.$nextTick(()=>{
        this.$refs.mytable.doLayout()
      })
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => {
          if (item.departmentName !=='小计') return Number(item[column.property])
        });
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toLocaleString(undefined, {'minimumFractionDigits':2,'maximumFractionDigits':2})+' 元';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    /**
     * 单元格样式
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     */
    cellStyle({row, column, rowIndex, columnIndex}){
      if (columnIndex === 0) {
        return {
          backgroundColor: 'white'
        }
      }
    },
    /**
     * 行样式
     * @param row
     * @param rowIndex
     */
    rowStyle({row, rowIndex}){
      if (row.departmentName === '小计') {
        return {
          // backgroundColor: 'pink'
        }
      }
    }



  },
}
</script>

<style scoped lang="scss">
.el-table {
  ::-webkit-scrollbar-track-piece {
    background-color: #fff;
  }
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    background-color: #fff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: rgba(144, 146, 152, 0.3);
  }
}
</style>
